import { Link } from "react-router-dom";
import Header from "../Header";

const PageNotFound = () => {
  return (
    <>
      <Header />
      <section class="py-10 px-10">
        <div class="">
          <h1 className="font-bold text-5xl text-center my-7 mx-auto bg-clip-text bg-gradient-to-r from-fuchsia-500 via-fuchsia-500 to-sky-500 text-transparent max-w-3xl leading-relaxed font-poppins mobile:text-2xl sm:text-3xl">
            Whoopsie! 404 Page Not Found
          </h1>
          <div class="text-center my-20">
            <h3 className="font-bold bg-clip-text bg-gradient-to-r from-purple-200 via-purple-400 to-indigo-900 text-transparent text-2xl leading-9 font-poppins mb-5">
              Look like you're lost
            </h3>
            <p className="font-bold text-white text-2xl leading-9 font-poppins mb-5 opacity-70">
              The page you are looking for Is not available!
            </p>
            <div className="mt-10">
              <Link
                to="/"
                class="text-xl font-normal text-white opacity-60 py-3 px-4 text-green-lgreen border-2 rounded-lg border-green-lgreen hover:opacity-40 hover:text-green-600"
              >
                Go to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default PageNotFound;
